import styled, { css } from "styled-components";

export const AreaChartRoot = styled.div(
    () => css`
        max-height: 18rem;
    `,
);
